import React from "react";
import { Link } from "react-router-dom";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import moment from "moment/moment";
import GridAd from "../../components/gridAd/gridAd.jsx";
import "../grid/grid.scss";

const Grid = ({ items, isLoading }) => {
    return isLoading ? (<div className="loading" />) : (
        <div className="grid">
            {items.map((item, index) => (
                <React.Fragment key={item.id}>
                    <Link className="item" to={"/post/" + item.url}>
                        <Link className="top" to={"/" + item.profile_username}>
                            <div className="profilePic">
                                <img src={"https://api.kolhaupt.it/uploads/" + item.profile_img} alt="Profilbild" />
                            </div>
                            <div className="profileData">
                                <span className="name">{item.profile_name}</span>
                                <span className="username">@{item.profile_username}</span>
                            </div>
                        </Link>
                        {item.img && <img src={"https://api.kolhaupt.it/uploads/" + item.img} alt="Beitragtitel" />}
                        <div className="heading">
                            {item.start_date
                                ? <div className="date">
                                    <span className="day">{moment(item.start_date).format("D.")}</span>
                                    <span className="month">{moment(item.start_date).format("MMM")}</span>
                                </div>
                                : <div className="info">
                                    <InfoOutlinedIcon />
                                </div>
                            }
                            <div className="right">
                                <h2>{item.title}</h2>
                                {item.start_date && <span>{moment(item.start_date).format("H:mm")} Uhr</span>}
                            </div>
                        </div>
                        <div className="text">
                            <p>{item.desc}</p>
                        </div>
                    </Link>

                    {(index + 1) % 3 === 0 && (
                        <div className="item ad-item" key={`ad-${index}`}>
                            <GridAd
                                adClient="ca-pub-3684922184809347"  // <- Deine AdSense Publisher-ID
                                adSlot="7819314062"
                            />
                        </div>
                    )}
                </React.Fragment>
            ))}
        </div>
    );
};

export default Grid;